import React from 'react';

import { IRaffle, RaffleStatus } from 'src/@types/raffles';
import useModal from 'src/hooks/useModal';
import useAuthStore from 'src/store/authStore';
import Button from 'src/ui/Button';
import { createPublicImageUrl } from 'src/utils/url';

import RaffleEndCounter from '../../EndCounter';
import RaffleParticipants from '../RaffleParticipants';

import s from './style.module.scss';

// import { ReactComponent as PeopleIcon } from '../../../assets/icons/people.svg';
import CoinImage from '../../../assets/images/coins/goldcoin.png';

interface IRaffleCardProps {
  item: IRaffle;
  onClick?: () => void;
}

const apiUrl = process.env.REACT_APP_API_URL;

const RaffleCard = ({ item, onClick }: IRaffleCardProps) => {
  const { user, userSettings } = useAuthStore();
  const isUserLoggedIn = user !== null;
  const { isOpen, openModal, closeModal } = useModal();

  const handleJoinClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // if (!isUserLoggedIn) {
    //   // show login modal
    //   openModal();
    // } else {
    if (onClick) {
      e.stopPropagation();
      onClick();
      // }
    }
  };

  const isSvgImage = item.imageId !== null;
  // && /weekly|monthly|daily/i.test(item.name || '');
  const imageUrl = item.image
    ? createPublicImageUrl(item.image.id)
    : item.imageId
      ? createPublicImageUrl(item.imageId)
      : CoinImage;

  return (
    <>
      <div className={`${s.card} ${isSvgImage ? s.card__svg : ''}`}>
        {isSvgImage ? (
          <div className={s.card__ticket_container}>
            <div className={s.card__ticket_bg}>
              <img
                src={imageUrl}
                alt="ticket"
                className={s.card__ticket_image}
              />
            </div>
            <div className={s.card__ticket_overlay}>
              <div className={s.card__content}>
                <div className={s.card__title}>{item.name}</div>
                <RaffleParticipants
                  winners={item.numberOfWinners}
                  maxParticipants={item.maxPlayers}
                  maxWinners={item.maxWinners}
                  isUnlimitedPlayers={item.unlimitedPlayers}
                  participants={item.numberOfPlayers}
                />

                <RaffleEndCounter endDate={item.endDate} />
                {item.status === RaffleStatus.COMPLETED ||
                item.status === RaffleStatus.UPCOMING ||
                item.joined ? (
                  <Button onClick={handleJoinClick} isOutlined>
                    Review
                  </Button>
                ) : (
                  <Button onClick={handleJoinClick}>Join</Button>
                )}
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className={s.card__bg} />

            <div className={s.card__content}>
              <div className={s.card__head}>
                <div className={s.card__image}>
                  <img src={imageUrl} alt="coin" />
                </div>
              </div>

              <div className={s.card__content}>
                <div className={s.card__title}>{item.name}</div>
                <RaffleParticipants
                  winners={item.numberOfWinners}
                  maxParticipants={item.maxPlayers}
                  maxWinners={item.maxWinners}
                  isUnlimitedPlayers={item.unlimitedPlayers}
                  participants={item.numberOfPlayers}
                />

                <RaffleEndCounter endDate={item.endDate} />
                {item.status === RaffleStatus.COMPLETED ||
                item.status === RaffleStatus.UPCOMING ||
                item.joined ? (
                  <Button onClick={handleJoinClick} isOutlined>
                    Review
                  </Button>
                ) : (
                  <Button onClick={handleJoinClick}>Join</Button>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {/* <Modal maxWidth='sm' isCloseIcon open={isOpen} handleClose={closeModal}>
        <LoginWarning />
      </Modal> */}
    </>
  );
};

export default RaffleCard;
